"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InstallStatusHelper = require("ui-addon-scriptloader/InstallStatusHelper");

var _default = {
  fetchScriptLoaderStatus: function fetchScriptLoaderStatus() {
    return (0, _InstallStatusHelper.getInstallStatus)({
      useCache: false
    });
  }
};
exports.default = _default;
module.exports = exports.default;